import styled from 'styled-components';
import { FinalLinescoreWrapper } from './Final.style'

export const FinalMiniLinescoreWrapper = styled(FinalLinescoreWrapper)`
    border-top: 1px solid var(--gameday-divider-color);
`;

export const FinalMiniTopWrapper = styled.div`
    background-color: var(--gameday-background-color);
    padding-bottom: var(--gameday-section-padding-sm);
`;
